exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".onboard-questions__answer{display:flex;justify-content:space-between}.onboard-questions__answer span{display:table}", ""]);

// exports
